import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Vote from '../vote';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';

class Interact extends React.PureComponent {
    static propTypes = {
        keywords: PropTypes.string,
        voteId: PropTypes.string,
        shareInfo: PropTypes.object,
        content: PropTypes.object,
    };

    render() {
        const { keywords, voteId, shareInfo, content } = this.props;
        const { isCloseShare } = content;

        return (
            <>
                <Vote keywords={keywords} voteId={voteId} content={content} />
                {!isCloseShare && (
                    <div className={styles.share_box}>
                        <ContentShare shareInfo={shareInfo} />
                    </div>
                )}
            </>
        );
    }
}

export default errorBoundary(Interact);
